import React, { useEffect, useMemo, useState } from "react";
import Swal from "sweetalert2";
import ImportarCatalogoExcel from "./importar-catalogo-excel";

const API_BASE = "https://api.checkmark.mx/";
const ACCESS_TOKEN =
  "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3";

const ALL_FILTER = "__all__";

const GLOBAL_AGENCY_OPTION = { label: "Sin agencia / Global", value: "" };

// brand = marca con la que se guardan accesorios/garantías de esa agencia.
// "all" = multimarca (seminuevos): el registro aplica a cualquier marca.
const AGENCY_DIRECTORY = [
  { label: "Seminuevos Gocar Azcapotzalco", value: "ag0028_5c33da0cc1c4d", brand: "all" },
  { label: "Renault San Ángel", value: "ag0532_5598bb1c4042b", brand: "Renault" },
  { label: "Honda Santa Fe", value: "ag0532_5598bb1c488c9", brand: "Honda" },
  { label: "Nissan Aragón", value: "ag0532_5598bb1c503e6", brand: "Nissan" },
  { label: "Volkswagen León Motors", value: "ag0532_5598bb1c51d78", brand: "Volkswagen" },
  { label: "Gocar Seminuevos León Norte", value: "ag0532_5598bb1c56605", brand: "all" },
  { label: "Nissan Santa Clara", value: "ag0532_5598bb1c86d5a", brand: "Nissan" },
  { label: "Renault Universidad", value: "ag0533_5598bb1d621ab", brand: "Renault" },
  { label: "Gocar Seminuevos León Irapuato", value: "ag0931_6500d38be2bc6", brand: "all" },
  { label: "Gocar Seminuevos León Sur", value: "ag1035_6500d3cb15aed", brand: "all" },
  { label: "MG Ecatepec", value: "ag1150_5b44ccb6362b8", brand: "MG" },
  { label: "MG Toluca", value: "ag2327_620bfdaf30656", brand: "MG" },
  { label: "Chirey Ecatepec", value: "ag3307_631f6d5397531", brand: "Chirey" },
  { label: "MG Metepec", value: "ag3636_61d5d72451639", brand: "MG" },
  { label: "Cupra Garage León", value: "ag3651_663021039f3f2", brand: "Cupra" },
  { label: "Renault Ajusco", value: "ag3912_5980f500b41b4", brand: "Renault" },
  { label: "MG Ecatepec - Nuevos", value: "ag4931_691e032bd8757", brand: "MG" },
  { label: "Seat Spanicar - Nuevos", value: "ag5348_691e042c59a67", brand: "Seat" },
  { label: "Honda Los Cabos", value: "ag5423_5a8736ef2eeb7", brand: "Honda" },
  { label: "Honda Metepec", value: "ag5457_5e20f7d1c1032", brand: "Honda" },
  { label: "Honda Tollocan", value: "ag5650_5e20f842e21a6", brand: "Honda" },
  { label: "Nissan Texcoco", value: "ag5713_5c33d949e445e", brand: "Nissan" },
  { label: "Renault San Ajusco - Nuevos", value: "ag5822_5bacfe1e8a7aa", brand: "Renault" },
  { label: "Nissan Tecámac", value: "ag5912_5c33d9c0c10df", brand: "Nissan" },
];

const defaultBrandOptions = [
  "Nissan",
  "all",
  "Renault",
  "Honda",
  "Volkswagen",
  "MG",
  "Chirey",
  "Seat",
  "Cupra",
];

const defaultSubTipoOptions = ["Auto", "SUV", "Pick-Up y Comercial"];

const emptyExtra = {
  id: "",
  title: "",
  description: "",
  modelo: "",
  price: "",
  image: "",
  video: "",
  pdf: "",
  type: "accesorios",
  brand: "Nissan",
  year: new Date().getFullYear(),
  available: "true",
  options: "",
  ag_id: "",
};

const emptyNuevo = {
  id_scraping: "",
  id_publicacion: "",
  nombre: "",
  descripcion_corta: "",
  list_details: "[]",
  img: "",
  anio: new Date().getFullYear().toString(),
  cuidad: "No aplica",
  kilometraje: "0",
  tipo_pago: "Fijo",
  precio_contado: "",
  marca: "Nissan",
  modelo: "",
  sub_tipo: "",
  color: "Sin color",
  dealer: "nissan",
  fuente: "nissan",
  json_imgs: "[]",
  colores_img: "[]",
  colores: "[]",
  versiones: "[]",
  url_cotizacion:
    "https://www.nissan.com.mx/credi-nissan/payment-estimator.html",
  url_ficha_tecnica: "",
  activo: 1,
};

const normalizeEmail = (email = "") =>
  String(email || "")
    .trim()
    .toLowerCase();

const normalizeText = (value = "") =>
  String(value ?? "")
    .trim()
    .toLowerCase();

const getLoggedUserEmail = () =>
  normalizeEmail(localStorage.getItem("userEmail") ?? "");

// Igual que en app-menu.jsx / app-route.jsx: el login guarda
// JSON.stringify(usuario.modulos) y la BD ya regresa "modulos" como texto
// JSON, así que en localStorage queda doblemente codificado (un texto que
// contiene la lista). Se acepta lista, texto JSON o texto separado por comas.
const getUserModules = () => {
  try {
    const rawModules = localStorage.getItem("modulos");

    if (!rawModules) return [];

    const parsedModules = JSON.parse(rawModules);

    if (Array.isArray(parsedModules)) {
      return parsedModules.map((module) => String(module).trim());
    }

    if (typeof parsedModules === "string") {
      try {
        const parsedAgain = JSON.parse(parsedModules);

        if (Array.isArray(parsedAgain)) {
          return parsedAgain.map((module) => String(module).trim());
        }
      } catch (error) {
        return parsedModules
          .split(",")
          .map((module) => module.trim())
          .filter(Boolean);
      }
    }

    return [];
  } catch (error) {
    return [];
  }
};

const isAllowedFrontend = (modules) =>
  Array.isArray(modules) && modules.includes("babilonia-catalog-admin");

const cleanMoney = (value = "") =>
  String(value ?? "")
    .replace(/,/g, "")
    .replace(/\$/g, "")
    .replace(/[^\d.-]/g, "")
    .trim();

const formatMoney = (value = 0) =>
  Number(cleanMoney(value) || 0).toLocaleString("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
  });

const jsonPretty = (value, fallback = "[]") => {
  if (value === null || value === undefined || value === "") return fallback;
  if (typeof value === "object") return JSON.stringify(value, null, 2);

  try {
    return JSON.stringify(JSON.parse(value), null, 2);
  } catch {
    return String(value);
  }
};

const isActiveExtra = (item) =>
  item?.available === true ||
  item?.available === "true" ||
  item?.available === 1 ||
  item?.available === "1";

const isActiveNuevo = (item) => Number(item?.activo) === 1;

const controlStyle = {
  color: "#111111",
  backgroundColor: "#ffffff",
};

const statusBadgeStyle = (active) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 78,
  padding: "5px 10px",
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 700,
  lineHeight: 1,
  backgroundColor: active ? "#198754" : "#6c757d",
  color: "#ffffff",
  border: "0",
});

const cancelButtonStyle = {
  backgroundColor: "#ffffff",
  border: "1px solid #6c757d",
  color: "#343a40",
  fontWeight: 600,
};

const tableStyle = {
  minWidth: 1080,
};

const tableHeadCellStyle = {
  backgroundColor: "#003f7f",
  color: "#ffffff",
  borderColor: "#003f7f",
  fontWeight: 700,
  whiteSpace: "nowrap",
  verticalAlign: "middle",
};

const tableCellStyle = {
  color: "#111111",
  verticalAlign: "middle",
};

const uniqueByValue = (options = []) => {
  const map = new Map();

  options.forEach((option) => {
    const value = option?.value ?? "";
    const label = option?.label ?? value;
    const key = String(value);

    if (!map.has(key)) {
      map.set(key, { value, label });
    }
  });

  return Array.from(map.values()).sort((a, b) =>
    String(a.label).localeCompare(String(b.label), "es", {
      sensitivity: "base",
    }),
  );
};

const getAgencyLabel = (agId = "") => {
  const normalizedAgId = String(agId || "").trim();

  if (!normalizedAgId) return "Sin agencia / Global";

  const found = AGENCY_DIRECTORY.find(
    (agencia) => agencia.value === normalizedAgId,
  );

  return found?.label || normalizedAgId;
};

const getTypeLabel = (type = "") => {
  const normalizedType = normalizeText(type);

  if (normalizedType === "accesorios") return "Accesorios";
  if (normalizedType === "garantias") return "Garantías";

  return type || "Sin tipo";
};

const getExtraBrandOptions = (items = [], includeDefaults = false) => {
  const apiOptions = items
    .map((item) => String(item?.brand ?? "").trim())
    .filter(Boolean)
    .map((brand) => ({ value: brand, label: brand }));

  const defaultOptions = includeDefaults
    ? defaultBrandOptions.map((brand) => ({ value: brand, label: brand }))
    : [];

  return uniqueByValue([...apiOptions, ...defaultOptions]);
};

const getExtraTypeOptions = (items = []) => {
  const apiOptions = items
    .map((item) => String(item?.type ?? "").trim())
    .filter(Boolean)
    .map((type) => ({ value: type, label: getTypeLabel(type) }));

  return uniqueByValue(apiOptions);
};

const getExtraAgencyOptions = (items = [], includeDefaults = false) => {
  const apiOptions = items.map((item) => {
    const value = String(item?.ag_id ?? "").trim();
    return {
      value,
      label: getAgencyLabel(value),
    };
  });

  const defaultOptions = includeDefaults
    ? [GLOBAL_AGENCY_OPTION, ...AGENCY_DIRECTORY]
    : [];

  return uniqueByValue([...apiOptions, ...defaultOptions]);
};

const getNuevoMarcaOptions = (items = []) => {
  const apiOptions = items
    .map((item) => String(item?.marca ?? "").trim())
    .filter(Boolean)
    .map((marca) => ({ value: marca, label: marca }));

  return uniqueByValue(apiOptions);
};

const getNuevoSubTipoOptions = (items = [], includeDefaults = false) => {
  const apiOptions = items
    .map((item) => String(item?.sub_tipo ?? "").trim())
    .filter(Boolean)
    .map((subTipo) => ({ value: subTipo, label: subTipo }));

  const defaultOptions = includeDefaults
    ? defaultSubTipoOptions.map((subTipo) => ({ value: subTipo, label: subTipo }))
    : [];

  return uniqueByValue([...apiOptions, ...defaultOptions]);
};

const getExtraStatusOptions = (items = []) => {
  const hasActive = items.some((item) => isActiveExtra(item));
  const hasInactive = items.some((item) => !isActiveExtra(item));
  const options = [];

  if (hasActive) options.push({ value: "true", label: "Activos" });
  if (hasInactive) options.push({ value: "false", label: "Inactivos" });

  return options.length
    ? options
    : [
        { value: "true", label: "Activos" },
        { value: "false", label: "Inactivos" },
      ];
};

const getNuevoStatusOptions = (items = []) => {
  const hasActive = items.some((item) => isActiveNuevo(item));
  const hasInactive = items.some((item) => !isActiveNuevo(item));
  const options = [];

  if (hasActive) options.push({ value: "1", label: "Activos" });
  if (hasInactive) options.push({ value: "0", label: "Inactivos" });

  return options.length
    ? options
    : [
        { value: "1", label: "Activos" },
        { value: "0", label: "Inactivos" },
      ];
};

const Field = ({ label, children, className = "col-md-6 mb-3" }) => (
  <div className={className}>
    <label className="form-label fw-semibold">{label}</label>
    {children}
  </div>
);

const TextInput = ({ style = {}, ...props }) => (
  <input
    className="form-control"
    style={{ ...controlStyle, ...style }}
    {...props}
  />
);

const TextArea = ({ rows = 3, style = {}, ...props }) => (
  <textarea
    className="form-control"
    rows={rows}
    style={{ ...controlStyle, ...style }}
    {...props}
  />
);

const SelectInput = ({ children, style = {}, ...props }) => (
  <select
    className="form-select"
    style={{ ...controlStyle, ...style }}
    {...props}
  >
    {children}
  </select>
);

const Th = ({ children, style = {} }) => (
  <th style={{ ...tableHeadCellStyle, ...style }}>{children}</th>
);

function BabiloniaCatalogAdmin() {
  const [userEmail, setUserEmail] = useState("");
  const [userModules, setUserModules] = useState(getUserModules());
  const [accessStatus, setAccessStatus] = useState("checking");
  const [tab, setTab] = useState("extras");
  const [loading, setLoading] = useState(false);

  // Mismo patrón que app-menu.jsx / agencias-cotizador-admin.js: si el
  // login se completó en otra pestaña o el localStorage cambió después de
  // montar este componente, lo recoge al volver el foco o detectar el cambio.
  useEffect(() => {
    const refreshUserData = () => {
      setUserModules(getUserModules());
    };

    window.addEventListener("storage", refreshUserData);
    window.addEventListener("focus", refreshUserData);

    return () => {
      window.removeEventListener("storage", refreshUserData);
      window.removeEventListener("focus", refreshUserData);
    };
  }, []);

  const [extras, setExtras] = useState([]);
  const [extrasFilterData, setExtrasFilterData] = useState([]);
  const [extrasFilters, setExtrasFilters] = useState({
    q: "",
    type: ALL_FILTER,
    brand: ALL_FILTER,
    ag_id: ALL_FILTER,
    available: "true",
  });

  const [extraForm, setExtraForm] = useState(emptyExtra);
  const [showExtraForm, setShowExtraForm] = useState(false);
  const [showImportExcel, setShowImportExcel] = useState(false);

  const [nuevos, setNuevos] = useState([]);
  const [nuevosFilterData, setNuevosFilterData] = useState([]);
  const [nuevosFilters, setNuevosFilters] = useState({
    q: "",
    marca: ALL_FILTER,
    sub_tipo: ALL_FILTER,
    activo: "1",
  });

  const [nuevoForm, setNuevoForm] = useState(emptyNuevo);
  const [showNuevoForm, setShowNuevoForm] = useState(false);

  const authPayload = useMemo(
    () => ({
      access_token: ACCESS_TOKEN,
      correo_usuario: userEmail,
      modulos: userModules,
    }),
    [userEmail, userModules],
  );

  const extraTypeOptions = useMemo(
    () => getExtraTypeOptions(extrasFilterData),
    [extrasFilterData],
  );

  const extraBrandFilterOptions = useMemo(
    () => getExtraBrandOptions(extrasFilterData),
    [extrasFilterData],
  );

  const extraBrandFormOptions = useMemo(
    () => getExtraBrandOptions(extrasFilterData, true),
    [extrasFilterData],
  );

  const extraAgencyFilterOptions = useMemo(
    () => getExtraAgencyOptions(extrasFilterData),
    [extrasFilterData],
  );

  const extraAgencyFormOptions = useMemo(
    () => getExtraAgencyOptions(extrasFilterData, true),
    [extrasFilterData],
  );

  const extraStatusOptions = useMemo(
    () => getExtraStatusOptions(extrasFilterData),
    [extrasFilterData],
  );

  const nuevoMarcaOptions = useMemo(
    () => getNuevoMarcaOptions(nuevosFilterData),
    [nuevosFilterData],
  );

  const nuevoSubTipoFilterOptions = useMemo(
    () => getNuevoSubTipoOptions(nuevosFilterData),
    [nuevosFilterData],
  );

  const nuevoSubTipoFormOptions = useMemo(
    () => getNuevoSubTipoOptions(nuevosFilterData, true),
    [nuevosFilterData],
  );

  const nuevoStatusOptions = useMemo(
    () => getNuevoStatusOptions(nuevosFilterData),
    [nuevosFilterData],
  );

  const postJson = async (url, payload = {}) => {
    const resp = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...authPayload,
        ...payload,
      }),
    });

    const data = await resp.json().catch(() => ({}));

    if (!resp.ok || data.status === "error") {
      throw new Error(data.message || "Ocurrió un error en la solicitud.");
    }

    return data;
  };

  const getExtrasListPayload = (filters = extrasFilters) => ({
    q: filters.q,
    type: filters.type === ALL_FILTER ? "all" : filters.type,
    brand: filters.brand === ALL_FILTER ? "all" : filters.brand,
    ag_id:
      filters.ag_id === ALL_FILTER || filters.ag_id === ""
        ? "all"
        : filters.ag_id,
    available: filters.available === ALL_FILTER ? "all" : filters.available,
  });

  const getNuevosListPayload = (filters = nuevosFilters) => ({
    ...filters,
    marca: filters.marca === ALL_FILTER ? "" : filters.marca,
    sub_tipo: filters.sub_tipo === ALL_FILTER ? "all" : filters.sub_tipo,
    activo: filters.activo === ALL_FILTER ? "all" : filters.activo,
  });

  const applyExtrasClientFilters = (items = [], filters = extrasFilters) => {
    const q = normalizeText(filters.q);

    return items.filter((item) => {
      const itemText = normalizeText(
        `${item?.title ?? ""} ${item?.description ?? ""} ${item?.modelo ?? ""}`,
      );
      const itemType = String(item?.type ?? "").trim();
      const itemBrand = String(item?.brand ?? "").trim();
      const itemAgId = String(item?.ag_id ?? "").trim();
      const itemAvailable = isActiveExtra(item) ? "true" : "false";

      if (q && !itemText.includes(q)) return false;

      if (filters.type !== ALL_FILTER && itemType !== filters.type) {
        return false;
      }

      if (filters.brand !== ALL_FILTER && itemBrand !== filters.brand) {
        return false;
      }

      if (filters.ag_id !== ALL_FILTER && itemAgId !== filters.ag_id) {
        return false;
      }

      if (
        filters.available !== ALL_FILTER &&
        itemAvailable !== filters.available
      ) {
        return false;
      }

      return true;
    });
  };

  const checkAccess = async () => {
    const email = getLoggedUserEmail();
    const modules = getUserModules();

    setUserEmail(email);
    setUserModules(modules);

    if (!isAllowedFrontend(modules)) {
      setAccessStatus("denied");
      return;
    }

    try {
      const resp = await fetch(
        `${API_BASE}admin/babilonia/catalogo/check-access`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            access_token: ACCESS_TOKEN,
            correo_usuario: email,
            modulos: modules,
          }),
        },
      );

      const data = await resp.json().catch(() => ({}));

      if (!resp.ok || data.allowed !== true) {
        setAccessStatus("denied");
        return;
      }

      setAccessStatus("allowed");
    } catch (error) {
      setAccessStatus("denied");
    }
  };

  const loadExtrasFilterData = async () => {
    if (accessStatus !== "allowed") return;

    try {
      const data = await postJson(
        `${API_BASE}admin/babilonia/accesorios-garantias/list`,
        {
          q: "",
          type: "all",
          brand: "all",
          ag_id: "all",
          available: "all",
        },
      );

      const items = Array.isArray(data.data) ? data.data : [];
      setExtrasFilterData(items);
    } catch (error) {
      setExtrasFilterData([]);
    }
  };

  const loadNuevosFilterData = async () => {
    if (accessStatus !== "allowed") return;

    try {
      const data = await postJson(`${API_BASE}admin/babilonia/nuevos/list`, {
        q: "",
        marca: "",
        sub_tipo: "all",
        activo: "all",
      });

      const items = Array.isArray(data.data) ? data.data : [];
      setNuevosFilterData(items);
    } catch (error) {
      setNuevosFilterData([]);
    }
  };

  const loadExtras = async () => {
    if (accessStatus !== "allowed") return;

    setLoading(true);

    try {
      const data = await postJson(
        `${API_BASE}admin/babilonia/accesorios-garantias/list`,
        getExtrasListPayload(),
      );

      const items = Array.isArray(data.data) ? data.data : [];
      const filteredItems = applyExtrasClientFilters(items);

      setExtras(filteredItems);

      if (!extrasFilterData.length) {
        setExtrasFilterData(items);
      }
    } catch (error) {
      Swal.fire("Error", error.message, "error");
      setExtras([]);
    } finally {
      setLoading(false);
    }
  };

  const loadNuevos = async () => {
    if (accessStatus !== "allowed") return;

    setLoading(true);

    try {
      const data = await postJson(
        `${API_BASE}admin/babilonia/nuevos/list`,
        getNuevosListPayload(),
      );

      const items = Array.isArray(data.data) ? data.data : [];
      setNuevos(items);

      if (!nuevosFilterData.length) {
        setNuevosFilterData(items);
      }
    } catch (error) {
      Swal.fire("Error", error.message, "error");
      setNuevos([]);
    } finally {
      setLoading(false);
    }
  };

  const refreshExtras = async () => {
    await Promise.all([loadExtras(), loadExtrasFilterData()]);
  };

  const refreshNuevos = async () => {
    await Promise.all([loadNuevos(), loadNuevosFilterData()]);
  };

  useEffect(() => {
    checkAccess();
  }, []);

  useEffect(() => {
    if (accessStatus !== "allowed") return;

    if (tab === "extras") {
      loadExtrasFilterData();
    }

    if (tab === "nuevos") {
      loadNuevosFilterData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessStatus, tab]);

  useEffect(() => {
    if (accessStatus !== "allowed" || tab !== "extras") return;

    const timer = setTimeout(() => {
      loadExtras();
    }, 300);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessStatus, tab, extrasFilters]);

  useEffect(() => {
    if (accessStatus !== "allowed" || tab !== "nuevos") return;

    const timer = setTimeout(() => {
      loadNuevos();
    }, 300);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessStatus, tab, nuevosFilters]);

  const openNewExtra = () => {
    setExtraForm({
      ...emptyExtra,
      options: JSON.stringify(
        {
          size: [{ text: "", price: "0.00" }],
        },
        null,
        2,
      ),
    });
    setShowExtraForm(true);
  };

  const openEditExtra = (item) => {
    setExtraForm({
      ...emptyExtra,
      ...item,
      available: isActiveExtra(item) ? "true" : "false",
      options: jsonPretty(item.options, ""),
    });
    setShowExtraForm(true);
  };

  const saveExtra = async () => {
    if (!extraForm.title.trim()) {
      Swal.fire("Falta título", "El título es obligatorio.", "warning");
      return;
    }

    if (!["accesorios", "garantias"].includes(extraForm.type)) {
      Swal.fire(
        "Tipo inválido",
        "Selecciona accesorios o garantias.",
        "warning",
      );
      return;
    }

    const price = cleanMoney(extraForm.price);
    let options = extraForm.options;

    if (!options.trim()) {
      options = JSON.stringify({
        size: [{ text: extraForm.title, price: Number(price || 0).toFixed(2) }],
      });
    } else {
      try {
        JSON.parse(options);
      } catch {
        Swal.fire(
          "JSON inválido",
          "El campo options no es JSON válido.",
          "warning",
        );
        return;
      }
    }

    setLoading(true);

    try {
      await postJson(`${API_BASE}admin/babilonia/accesorios-garantias/save`, {
        ...extraForm,
        price,
        options,
      });

      setShowExtraForm(false);
      setExtraForm(emptyExtra);
      await refreshExtras();

      Swal.fire("Guardado", "El registro se guardó correctamente.", "success");
    } catch (error) {
      Swal.fire("Error", error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const deleteExtra = async (item) => {
    const result = await Swal.fire({
      icon: "warning",
      title: "¿Desactivar registro?",
      text: item.title,
      showCancelButton: true,
      confirmButtonText: "Sí, desactivar",
      cancelButtonText: "Cancelar",
    });

    if (!result.isConfirmed) return;

    setLoading(true);

    try {
      await postJson(`${API_BASE}admin/babilonia/accesorios-garantias/delete`, {
        id: item.id,
      });

      await refreshExtras();

      Swal.fire("Desactivado", "El registro fue desactivado.", "success");
    } catch (error) {
      Swal.fire("Error", error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const reactivateExtra = async (item) => {
    setLoading(true);

    try {
      await postJson(
        `${API_BASE}admin/babilonia/accesorios-garantias/reactivar`,
        {
          id: item.id,
        },
      );

      await refreshExtras();

      Swal.fire("Reactivado", "El registro fue reactivado.", "success");
    } catch (error) {
      Swal.fire("Error", error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const openNewNuevo = () => {
    setNuevoForm({
      ...emptyNuevo,
      versiones: JSON.stringify(
        [
          {
            version: "Sense TM",
            precio: 0,
          },
        ],
        null,
        2,
      ),
    });
    setShowNuevoForm(true);
  };

  const openEditNuevo = (item) => {
    setNuevoForm({
      ...emptyNuevo,
      ...item,
      list_details: jsonPretty(item.list_details, "[]"),
      json_imgs: jsonPretty(item.json_imgs, "[]"),
      colores_img: jsonPretty(item.colores_img, "[]"),
      colores: jsonPretty(item.colores, "[]"),
      versiones: jsonPretty(item.versiones, "[]"),
      activo: Number(item.activo || 0),
    });
    setShowNuevoForm(true);
  };

  const validateNuevoJsonFields = () => {
    const fields = [
      "list_details",
      "json_imgs",
      "colores_img",
      "colores",
      "versiones",
    ];

    for (const field of fields) {
      try {
        JSON.parse(nuevoForm[field] || "[]");
      } catch {
        Swal.fire(
          "JSON inválido",
          `El campo ${field} no es JSON válido.`,
          "warning",
        );
        return false;
      }
    }

    return true;
  };

  const saveNuevo = async () => {
    if (!nuevoForm.marca.trim() || !nuevoForm.modelo.trim()) {
      Swal.fire(
        "Datos incompletos",
        "Marca y modelo son obligatorios.",
        "warning",
      );
      return;
    }

    if (!validateNuevoJsonFields()) return;

    setLoading(true);

    try {
      await postJson(`${API_BASE}admin/babilonia/nuevos/save`, nuevoForm);

      setShowNuevoForm(false);
      setNuevoForm(emptyNuevo);
      await refreshNuevos();

      Swal.fire("Guardado", "El vehículo se guardó correctamente.", "success");
    } catch (error) {
      Swal.fire("Error", error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const deleteNuevo = async (item) => {
    const result = await Swal.fire({
      icon: "warning",
      title: "¿Desactivar vehículo?",
      text: `${item.marca} ${item.modelo} ${item.anio}`,
      showCancelButton: true,
      confirmButtonText: "Sí, desactivar",
      cancelButtonText: "Cancelar",
    });

    if (!result.isConfirmed) return;

    setLoading(true);

    try {
      await postJson(`${API_BASE}admin/babilonia/nuevos/delete`, {
        id_scraping: item.id_scraping,
      });

      await refreshNuevos();

      Swal.fire("Desactivado", "El vehículo fue desactivado.", "success");
    } catch (error) {
      Swal.fire("Error", error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const reactivateNuevo = async (item) => {
    setLoading(true);

    try {
      await postJson(`${API_BASE}admin/babilonia/nuevos/reactivar`, {
        id_scraping: item.id_scraping,
      });

      await refreshNuevos();

      Swal.fire("Reactivado", "El vehículo fue reactivado.", "success");
    } catch (error) {
      Swal.fire("Error", error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  if (accessStatus === "checking") {
    return (
      <div className="container py-4">
        <div className="alert alert-info mb-0">Validando permisos...</div>
      </div>
    );
  }

  if (accessStatus === "denied") {
    return (
      <div className="container py-4">
        <div className="alert alert-danger mb-0">
          No tienes permiso para acceder a este módulo.
          {userEmail ? (
            <div className="mt-2 small">Usuario detectado: {userEmail}</div>
          ) : (
            <div className="mt-2 small">
              No se pudo detectar el correo del usuario en sesión.
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid py-3">
      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 2000,
            background: "rgba(255,255,255,.65)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
          }}
        >
          Cargando...
        </div>
      )}

      <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
        <div>
          <h3 className="mb-0 black-text">Catálogo Babilonia</h3>
          <div className="text-muted">
            Administra accesorios, garantías y vehículos nuevos.
          </div>
          <div className="small text-success">Acceso: {userEmail}</div>
        </div>

        <div className="btn-group">
          <button
            type="button"
            className={`btn ${
              tab === "extras" ? "btn-primary" : "btn-outline-primary"
            }`}
            onClick={() => setTab("extras")}
          >
            Accesorios / Garantías
          </button>
          <button
            type="button"
            className={`btn ${
              tab === "nuevos" ? "btn-primary" : "btn-outline-primary"
            }`}
            onClick={() => setTab("nuevos")}
          >
            Vehículos nuevos
          </button>
        </div>
      </div>

      {tab === "extras" && (
        <>
          <div className="card mb-3">
            <div className="card-body">
              <div className="row g-2 align-items-end">
                <Field label="Buscar" className="col-md-3">
                  <TextInput
                    value={extrasFilters.q}
                    onChange={(e) =>
                      setExtrasFilters((prev) => ({
                        ...prev,
                        q: e.target.value,
                      }))
                    }
                    placeholder="Título, descripción o modelo"
                  />
                </Field>

                <Field label="Tipo" className="col-md-2">
                  <SelectInput
                    value={extrasFilters.type}
                    onChange={(e) =>
                      setExtrasFilters((prev) => ({
                        ...prev,
                        type: e.target.value,
                      }))
                    }
                  >
                    <option value={ALL_FILTER}>Todos</option>
                    {extraTypeOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </SelectInput>
                </Field>

                <Field label="Marca" className="col-md-2">
                  <SelectInput
                    value={extrasFilters.brand}
                    onChange={(e) =>
                      setExtrasFilters((prev) => ({
                        ...prev,
                        brand: e.target.value,
                      }))
                    }
                  >
                    <option value={ALL_FILTER}>Todas</option>
                    {extraBrandFilterOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </SelectInput>
                </Field>

                <Field label="Agencia" className="col-md-2">
                  <SelectInput
                    value={extrasFilters.ag_id}
                    onChange={(e) =>
                      setExtrasFilters((prev) => ({
                        ...prev,
                        ag_id: e.target.value,
                      }))
                    }
                  >
                    <option value={ALL_FILTER}>Todas</option>
                    {extraAgencyFilterOptions.map((option) => (
                      <option key={option.value || "global"} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </SelectInput>
                </Field>

                <Field label="Estado" className="col-md-1">
                  <SelectInput
                    value={extrasFilters.available}
                    onChange={(e) =>
                      setExtrasFilters((prev) => ({
                        ...prev,
                        available: e.target.value,
                      }))
                    }
                  >
                    <option value={ALL_FILTER}>Todos</option>
                    {extraStatusOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </SelectInput>
                </Field>

                <div className="col-md-2 d-flex gap-2 mb-3">
                  <button
                    type="button"
                    className="btn btn-secondary w-50"
                    onClick={refreshExtras}
                  >
                    Actualizar
                  </button>
                  <button
                    type="button"
                    className="btn btn-success w-50"
                    onClick={openNewExtra}
                  >
                    Nuevo
                  </button>
                </div>

                <div className="col-12 d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-outline-success btn-sm"
                    onClick={() => {
                      setShowExtraForm(false);
                      setShowImportExcel(true);
                    }}
                  >
                    Importar accesorios / garantías desde Excel
                  </button>
                </div>
              </div>
            </div>
          </div>

          {showImportExcel && (
            <ImportarCatalogoExcel
              postJson={postJson}
              apiBase={API_BASE}
              agencyOptions={AGENCY_DIRECTORY}
              brandOptions={defaultBrandOptions}
              tipoInicial={
                extrasFilters.type === "garantias" ? "garantias" : "accesorios"
              }
              onClose={() => setShowImportExcel(false)}
              onImported={refreshExtras}
            />
          )}

          {showExtraForm && (
            <div className="card mb-3 border-primary">
              <div className="card-header d-flex justify-content-between align-items-center">
                <strong>
                  {extraForm.id
                    ? `Editar #${extraForm.id}`
                    : "Nuevo accesorio / garantía"}
                </strong>
                <button
                  type="button"
                  className="btn btn-sm btn-primary"
                  onClick={() => setShowExtraForm(false)}
                >
                  Cerrar
                </button>
              </div>

              <div className="card-body">
                <div className="row">
                  <Field label="Título" className="col-md-8 mb-3">
                    <TextInput
                      value={extraForm.title}
                      onChange={(e) =>
                        setExtraForm((prev) => ({
                          ...prev,
                          title: e.target.value,
                        }))
                      }
                      placeholder="Ej. LOCALIZADOR 1 AÑO - Versa, Sentra, X-Trail"
                    />
                  </Field>

                  <Field label="Precio" className="col-md-2 mb-3">
                    <TextInput
                      value={extraForm.price}
                      onChange={(e) =>
                        setExtraForm((prev) => ({
                          ...prev,
                          price: e.target.value,
                        }))
                      }
                      placeholder="6100.00"
                    />
                  </Field>

                  <Field label="Año" className="col-md-2 mb-3">
                    <TextInput
                      value={extraForm.year}
                      onChange={(e) =>
                        setExtraForm((prev) => ({
                          ...prev,
                          year: e.target.value,
                        }))
                      }
                    />
                  </Field>

                  <Field label="Tipo" className="col-md-3 mb-3">
                    <SelectInput
                      value={extraForm.type}
                      onChange={(e) =>
                        setExtraForm((prev) => ({
                          ...prev,
                          type: e.target.value,
                        }))
                      }
                    >
                      <option value="accesorios">Accesorios</option>
                      <option value="garantias">Garantías</option>
                    </SelectInput>
                  </Field>

                  <Field label="Marca" className="col-md-3 mb-3">
                    <SelectInput
                      value={extraForm.brand}
                      onChange={(e) =>
                        setExtraForm((prev) => ({
                          ...prev,
                          brand: e.target.value,
                        }))
                      }
                    >
                      {extraBrandFormOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </SelectInput>
                  </Field>

                  <Field label="Agencia" className="col-md-3 mb-3">
                    <SelectInput
                      value={extraForm.ag_id || ""}
                      onChange={(e) =>
                        setExtraForm((prev) => ({
                          ...prev,
                          ag_id: e.target.value,
                        }))
                      }
                    >
                      {extraAgencyFormOptions.map((option) => (
                        <option key={option.value || "global"} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </SelectInput>
                  </Field>

                  <Field label="Disponible" className="col-md-3 mb-3">
                    <SelectInput
                      value={extraForm.available}
                      onChange={(e) =>
                        setExtraForm((prev) => ({
                          ...prev,
                          available: e.target.value,
                        }))
                      }
                    >
                      <option value="true">Activo</option>
                      <option value="false">Inactivo</option>
                    </SelectInput>
                  </Field>

                  <Field label="Descripción" className="col-md-6 mb-3">
                    <TextArea
                      value={extraForm.description}
                      onChange={(e) =>
                        setExtraForm((prev) => ({
                          ...prev,
                          description: e.target.value,
                        }))
                      }
                    />
                  </Field>

                  <Field
                    label="Modelo / texto de apoyo"
                    className="col-md-6 mb-3"
                  >
                    <TextArea
                      value={extraForm.modelo}
                      onChange={(e) =>
                        setExtraForm((prev) => ({
                          ...prev,
                          modelo: e.target.value,
                        }))
                      }
                    />
                  </Field>

                  <Field label="Imagen" className="col-md-4 mb-3">
                    <TextInput
                      value={extraForm.image}
                      onChange={(e) =>
                        setExtraForm((prev) => ({
                          ...prev,
                          image: e.target.value,
                        }))
                      }
                    />
                  </Field>

                  <Field label="Video" className="col-md-4 mb-3">
                    <TextInput
                      value={extraForm.video || ""}
                      onChange={(e) =>
                        setExtraForm((prev) => ({
                          ...prev,
                          video: e.target.value,
                        }))
                      }
                    />
                  </Field>

                  <Field label="PDF" className="col-md-4 mb-3">
                    <TextInput
                      value={extraForm.pdf || ""}
                      onChange={(e) =>
                        setExtraForm((prev) => ({
                          ...prev,
                          pdf: e.target.value,
                        }))
                      }
                    />
                  </Field>

                  <Field label="Options JSON" className="col-12 mb-3">
                    <TextArea
                      rows={5}
                      value={extraForm.options}
                      onChange={(e) =>
                        setExtraForm((prev) => ({
                          ...prev,
                          options: e.target.value,
                        }))
                      }
                      placeholder='{"size":[{"text":"LOCALIZADOR 1 AÑO","price":"6100.00"}]}'
                    />
                  </Field>

                  <div className="col-12 d-flex gap-2">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={saveExtra}
                    >
                      Guardar
                    </button>
                    <button
                      type="button"
                      className="btn"
                      style={cancelButtonStyle}
                      onClick={() => setShowExtraForm(false)}
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="card">
            <div className="table-responsive">
              <table
                className="table table-hover table-sm align-middle mb-0"
                style={tableStyle}
              >
                <thead>
                  <tr>
                    <Th>ID</Th>
                    <Th>Título</Th>
                    <Th>Tipo</Th>
                    <Th>Marca</Th>
                    <Th>Agencia</Th>
                    <Th>Precio</Th>
                    <Th>Estado</Th>
                    <Th style={{ width: 170 }}>Acciones</Th>
                  </tr>
                </thead>
                <tbody>
                  {extras.map((item) => (
                    <tr key={item.id}>
                      <td style={tableCellStyle}>{item.id}</td>
                      <td style={{ ...tableCellStyle, minWidth: 360 }}>
                        {item.title}
                      </td>
                      <td style={tableCellStyle}>{item.type}</td>
                      <td style={tableCellStyle}>{item.brand}</td>
                      <td style={tableCellStyle}>{getAgencyLabel(item.ag_id)}</td>
                      <td style={tableCellStyle}>{formatMoney(item.price)}</td>
                      <td style={tableCellStyle}>
                        <span style={statusBadgeStyle(isActiveExtra(item))}>
                          {isActiveExtra(item) ? "Activo" : "Inactivo"}
                        </span>
                      </td>
                      <td style={tableCellStyle}>
                        <div className="btn-group btn-group-sm">
                          <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={() => openEditExtra(item)}
                          >
                            Editar
                          </button>

                          {isActiveExtra(item) ? (
                            <button
                              type="button"
                              className="btn btn-outline-danger"
                              onClick={() => deleteExtra(item)}
                            >
                              Borrar
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-outline-success"
                              onClick={() => reactivateExtra(item)}
                            >
                              Activar
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}

                  {!extras.length && (
                    <tr>
                      <td colSpan="8" className="text-center text-muted py-4">
                        Sin registros.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}

      {tab === "nuevos" && (
        <>
          <div className="card mb-3">
            <div className="card-body">
              <div className="row g-2 align-items-end">
                <Field label="Buscar" className="col-md-4">
                  <TextInput
                    value={nuevosFilters.q}
                    onChange={(e) =>
                      setNuevosFilters((prev) => ({
                        ...prev,
                        q: e.target.value,
                      }))
                    }
                    placeholder="Nombre, marca o modelo"
                  />
                </Field>

                <Field label="Marca" className="col-md-2">
                  <SelectInput
                    value={nuevosFilters.marca}
                    onChange={(e) =>
                      setNuevosFilters((prev) => ({
                        ...prev,
                        marca: e.target.value,
                      }))
                    }
                  >
                    <option value={ALL_FILTER}>Todas</option>
                    {nuevoMarcaOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </SelectInput>
                </Field>

                <Field label="Subtipo" className="col-md-2">
                  <SelectInput
                    value={nuevosFilters.sub_tipo}
                    onChange={(e) =>
                      setNuevosFilters((prev) => ({
                        ...prev,
                        sub_tipo: e.target.value,
                      }))
                    }
                  >
                    <option value={ALL_FILTER}>Todos</option>
                    {nuevoSubTipoFilterOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </SelectInput>
                </Field>

                <Field label="Estado" className="col-md-2">
                  <SelectInput
                    value={nuevosFilters.activo}
                    onChange={(e) =>
                      setNuevosFilters((prev) => ({
                        ...prev,
                        activo: e.target.value,
                      }))
                    }
                  >
                    <option value={ALL_FILTER}>Todos</option>
                    {nuevoStatusOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </SelectInput>
                </Field>

                <div className="col-md-2 d-flex gap-2 mb-3">
                  <button
                    type="button"
                    className="btn btn-secondary w-50"
                    onClick={refreshNuevos}
                  >
                    Actualizar
                  </button>
                  <button
                    type="button"
                    className="btn btn-success w-50"
                    onClick={openNewNuevo}
                  >
                    Nuevo
                  </button>
                </div>
              </div>
            </div>
          </div>

          {showNuevoForm && (
            <div className="card mb-3 border-primary">
              <div className="card-header d-flex justify-content-between align-items-center">
                <strong>
                  {nuevoForm.id_scraping
                    ? `Editar vehículo #${nuevoForm.id_scraping}`
                    : "Nuevo vehículo"}
                </strong>
                <button
                  type="button"
                  className="btn btn-sm btn-primary"
                  onClick={() => setShowNuevoForm(false)}
                >
                  Cerrar
                </button>
              </div>

              <div className="card-body">
                <div className="row">
                  <Field label="Nombre" className="col-md-4 mb-3">
                    <TextInput
                      value={nuevoForm.nombre}
                      onChange={(e) =>
                        setNuevoForm((prev) => ({
                          ...prev,
                          nombre: e.target.value,
                        }))
                      }
                      placeholder="Nissan X-Trail"
                    />
                  </Field>

                  <Field label="Marca" className="col-md-2 mb-3">
                    <TextInput
                      value={nuevoForm.marca}
                      onChange={(e) =>
                        setNuevoForm((prev) => ({
                          ...prev,
                          marca: e.target.value,
                        }))
                      }
                    />
                  </Field>

                  <Field label="Modelo" className="col-md-2 mb-3">
                    <TextInput
                      value={nuevoForm.modelo}
                      onChange={(e) =>
                        setNuevoForm((prev) => ({
                          ...prev,
                          modelo: e.target.value,
                        }))
                      }
                      placeholder="X-Trail"
                    />
                  </Field>

                  <Field label="Año" className="col-md-2 mb-3">
                    <TextInput
                      value={nuevoForm.anio}
                      onChange={(e) =>
                        setNuevoForm((prev) => ({
                          ...prev,
                          anio: e.target.value,
                        }))
                      }
                    />
                  </Field>

                  <Field label="Activo" className="col-md-2 mb-3">
                    <SelectInput
                      value={nuevoForm.activo}
                      onChange={(e) =>
                        setNuevoForm((prev) => ({
                          ...prev,
                          activo: Number(e.target.value),
                        }))
                      }
                    >
                      <option value={1}>Activo</option>
                      <option value={0}>Inactivo</option>
                    </SelectInput>
                  </Field>

                  <Field label="Subtipo" className="col-md-3 mb-3">
                    <SelectInput
                      value={nuevoForm.sub_tipo}
                      onChange={(e) =>
                        setNuevoForm((prev) => ({
                          ...prev,
                          sub_tipo: e.target.value,
                        }))
                      }
                    >
                      <option value="">Selecciona</option>
                      {nuevoSubTipoFormOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </SelectInput>
                  </Field>

                  <Field label="Precio contado" className="col-md-3 mb-3">
                    <TextInput
                      value={nuevoForm.precio_contado}
                      onChange={(e) =>
                        setNuevoForm((prev) => ({
                          ...prev,
                          precio_contado: e.target.value,
                        }))
                      }
                      placeholder="Desde $692,900"
                    />
                  </Field>

                  <Field label="ID publicación" className="col-md-3 mb-3">
                    <TextInput
                      value={nuevoForm.id_publicacion}
                      onChange={(e) =>
                        setNuevoForm((prev) => ({
                          ...prev,
                          id_publicacion: e.target.value,
                        }))
                      }
                    />
                  </Field>

                  <Field label="Fuente" className="col-md-3 mb-3">
                    <TextInput
                      value={nuevoForm.fuente}
                      onChange={(e) =>
                        setNuevoForm((prev) => ({
                          ...prev,
                          fuente: e.target.value,
                        }))
                      }
                    />
                  </Field>

                  <Field label="Descripción corta" className="col-12 mb-3">
                    <TextArea
                      rows={3}
                      value={nuevoForm.descripcion_corta}
                      onChange={(e) =>
                        setNuevoForm((prev) => ({
                          ...prev,
                          descripcion_corta: e.target.value,
                        }))
                      }
                    />
                  </Field>

                  <Field label="Imagen principal" className="col-md-6 mb-3">
                    <TextInput
                      value={nuevoForm.img}
                      onChange={(e) =>
                        setNuevoForm((prev) => ({
                          ...prev,
                          img: e.target.value,
                        }))
                      }
                    />
                  </Field>

                  <Field label="URL ficha técnica" className="col-md-6 mb-3">
                    <TextInput
                      value={nuevoForm.url_ficha_tecnica}
                      onChange={(e) =>
                        setNuevoForm((prev) => ({
                          ...prev,
                          url_ficha_tecnica: e.target.value,
                        }))
                      }
                    />
                  </Field>

                  <Field label="URL cotización" className="col-md-6 mb-3">
                    <TextInput
                      value={nuevoForm.url_cotizacion}
                      onChange={(e) =>
                        setNuevoForm((prev) => ({
                          ...prev,
                          url_cotizacion: e.target.value,
                        }))
                      }
                    />
                  </Field>

                  <Field label="Dealer" className="col-md-6 mb-3">
                    <TextInput
                      value={nuevoForm.dealer}
                      onChange={(e) =>
                        setNuevoForm((prev) => ({
                          ...prev,
                          dealer: e.target.value,
                        }))
                      }
                    />
                  </Field>

                  <Field label="Versiones JSON" className="col-12 mb-3">
                    <TextArea
                      rows={8}
                      value={nuevoForm.versiones}
                      onChange={(e) =>
                        setNuevoForm((prev) => ({
                          ...prev,
                          versiones: e.target.value,
                        }))
                      }
                      placeholder='[{"version":"Advance 2 Row","precio":692900}]'
                    />
                  </Field>

                  <Field label="List details JSON" className="col-md-6 mb-3">
                    <TextArea
                      rows={5}
                      value={nuevoForm.list_details}
                      onChange={(e) =>
                        setNuevoForm((prev) => ({
                          ...prev,
                          list_details: e.target.value,
                        }))
                      }
                    />
                  </Field>

                  <Field label="Json imgs JSON" className="col-md-6 mb-3">
                    <TextArea
                      rows={5}
                      value={nuevoForm.json_imgs}
                      onChange={(e) =>
                        setNuevoForm((prev) => ({
                          ...prev,
                          json_imgs: e.target.value,
                        }))
                      }
                    />
                  </Field>

                  <Field label="Colores img JSON" className="col-md-6 mb-3">
                    <TextArea
                      rows={5}
                      value={nuevoForm.colores_img}
                      onChange={(e) =>
                        setNuevoForm((prev) => ({
                          ...prev,
                          colores_img: e.target.value,
                        }))
                      }
                    />
                  </Field>

                  <Field label="Colores JSON" className="col-md-6 mb-3">
                    <TextArea
                      rows={5}
                      value={nuevoForm.colores}
                      onChange={(e) =>
                        setNuevoForm((prev) => ({
                          ...prev,
                          colores: e.target.value,
                        }))
                      }
                    />
                  </Field>

                  <div className="col-12 d-flex gap-2">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={saveNuevo}
                    >
                      Guardar
                    </button>
                    <button
                      type="button"
                      className="btn"
                      style={cancelButtonStyle}
                      onClick={() => setShowNuevoForm(false)}
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="card">
            <div className="table-responsive">
              <table
                className="table table-hover table-sm align-middle mb-0"
                style={tableStyle}
              >
                <thead>
                  <tr>
                    <Th>ID</Th>
                    <Th>Nombre</Th>
                    <Th>Marca</Th>
                    <Th>Modelo</Th>
                    <Th>Año</Th>
                    <Th>Subtipo</Th>
                    <Th>Precio</Th>
                    <Th>Estado</Th>
                    <Th style={{ width: 170 }}>Acciones</Th>
                  </tr>
                </thead>
                <tbody>
                  {nuevos.map((item) => (
                    <tr key={item.id_scraping}>
                      <td style={tableCellStyle}>{item.id_scraping}</td>
                      <td style={{ ...tableCellStyle, minWidth: 260 }}>
                        {item.nombre}
                      </td>
                      <td style={tableCellStyle}>{item.marca}</td>
                      <td style={tableCellStyle}>{item.modelo}</td>
                      <td style={tableCellStyle}>{item.anio}</td>
                      <td style={tableCellStyle}>{item.sub_tipo}</td>
                      <td style={tableCellStyle}>
                        {item.precio_contado || formatMoney(item.precio_contado)}
                      </td>
                      <td style={tableCellStyle}>
                        <span style={statusBadgeStyle(isActiveNuevo(item))}>
                          {isActiveNuevo(item) ? "Activo" : "Inactivo"}
                        </span>
                      </td>
                      <td style={tableCellStyle}>
                        <div className="btn-group btn-group-sm">
                          <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={() => openEditNuevo(item)}
                          >
                            Editar
                          </button>

                          {isActiveNuevo(item) ? (
                            <button
                              type="button"
                              className="btn btn-outline-danger"
                              onClick={() => deleteNuevo(item)}
                            >
                              Borrar
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-outline-success"
                              onClick={() => reactivateNuevo(item)}
                            >
                              Activar
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}

                  {!nuevos.length && (
                    <tr>
                      <td colSpan="9" className="text-center text-muted py-4">
                        Sin registros.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default BabiloniaCatalogAdmin;